import { toastService } from "src/libraries/toast";
import { appStateModel } from "src/entities/appState/AppStateModel";
import { resourcesService } from "../entity/resources/ResourcesService";

export const deleteResourceUseCase = async (link: string, entityId: number, id: number) => {
    try {
        appStateModel.isLoading = true;
        const response = await resourcesService.delete(link, entityId, id);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
        }
    } catch (error) {
        console.warn('deleteResourceUseCase: ', error);
    } finally {
        appStateModel.isLoading = false;
    }
}   